













import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { Org } from "@/modules/budget/staffing-table/types";
const modelChangeEvent = 'change';
const modelUpdateEvent = 'update';

@Component
export default class CurYearField extends Vue {

    @Model(
        modelChangeEvent,
        {
            type: Object,
            required: true,
        },
    )
    public org!: Org | null;


    @Prop({
        type: Number,
        required: true,
    })
    public year!: number;

    private localYear: number | null = null

    public created() {
        this.$watch('localYear', (localYear: number | null) => {
            if (this.year !== localYear) {
                this.$emit(modelChangeEvent, localYear);
            }
        });

        this.$watch('org', (localYear: number | null) => {
            this.buildDateRange()
        });
    }

    private mounted() {
        this.buildDateRange()
    }

    private minYear: number | null = null
    private maxYear: number | null = null

    private buildDateRange() {
        let begDate: number | null = null;
        let endDate: number | null = null;

        if (this.org?.type === 'GU') {
            begDate = this.org.gu?.begDate ?? null;
            endDate = this.org.gu?.endDate ?? null;
        } else if (this.org?.type === 'KGKP') {
            begDate = this.org.kgkp?.begDate ?? null;
            endDate = this.org.kgkp?.endDate ?? null;
        }
        const begYear = begDate ? new Date(begDate + 12 * 60 * 60 * 1000).getFullYear() : null;
        const endYear = endDate ? new Date(endDate + 12 * 60 * 60 * 1000).getFullYear() : null;

        const minYear = begYear;
        const maxYear = endYear;

        this.minYear = minYear;
        this.maxYear = maxYear;

        const isWithinMin = minYear === null || this.year >= minYear;
        const isWithinMax = maxYear === null || this.year <= maxYear;

        if (isWithinMin && isWithinMax) {
            this.localYear = this.year;
            this.$emit(modelUpdateEvent, this.localYear);
        } else {
            this.localYear = this.minYear ?? new Date().getFullYear() + 1;
        }
    }

}
